import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Popover from '@/storybook/components/Popover/Popover';
import Button from '@/storybook/components/Button/Button';
import IconButton from '@/storybook/components/IconButton/IconButton';
import { EditIcon, TrashIcon } from '@/storybook/icons';
import { ThreeDotsIcon } from '@/components/base/Icons/RocheIconPack';
import { CHAT_HISTORY_TEST_IDS } from './testIds';
import styles from './ChatHistoryItemMenu.module.css';

interface ChatHistoryItemMenuProps {
  onRename: () => void;
  onDelete: () => void;
}

const ChatHistoryItemMenu: FC<ChatHistoryItemMenuProps> = ({ onRename, onDelete }) => {
  const { t } = useTranslation();

  const menuContent = (
    <div className={styles.menuPanel}>
      <Button
        variant="text"
        size="S"
        className={styles.menuItem}
        startIcon={<EditIcon className={styles.menuIcon} />}
        onClick={onRename}
        data-testid={CHAT_HISTORY_TEST_IDS.renameOption}
      >
        {t('components.aiChatDrawer.history.rename')}
      </Button>
      <Button
        variant="text"
        size="S"
        className={styles.menuItem}
        startIcon={<TrashIcon className={styles.menuIcon} />}
        onClick={onDelete}
        data-testid={CHAT_HISTORY_TEST_IDS.deleteOption}
      >
        {t('components.aiChatDrawer.history.delete')}
      </Button>
    </div>
  );

  return (
    <Popover
      size="S"
      noticePosition="bottom-left"
      raw
      withCloseButton={false}
      closeOnNoticeContentClick
      anchorContent={
        <IconButton
          appearance="text"
          size="S"
          icon={<ThreeDotsIcon height="1.8rem" width="1.8rem" />}
          aria-label={t('components.aiChatDrawer.history.moreOptionsAriaLabel')}
          data-testid={CHAT_HISTORY_TEST_IDS.itemMenuButton}
        />
      }
      noticeContent={menuContent}
    />
  );
};

export default ChatHistoryItemMenu;
